import { MdArrowForwardIos, MdErrorOutline } from 'react-icons/md';
import { CardInfoDisplay, DashboardCardType } from 'types';
import { Heading, Text, Tooltip } from 'components';
import { formatNumberEnsuringTwoDigits } from 'helpers';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';

interface Props {
  cardInfoDisplay: CardInfoDisplay;
  alert: boolean;
  quantity: number;
  type: DashboardCardType;
  action: () => void;
}

export function FilterCard({
  cardInfoDisplay,
  alert,
  quantity,
  type,
  action,
}: Props) {
  const { title, buttonLabel, bgIcon, tooltipMessage } = cardInfoDisplay;

  return (
    <S.Card $type={quantity === 0 ? 'default' : type} onClick={action}>
      <S.BackgroundIcon>{bgIcon}</S.BackgroundIcon>

      <S.CardWrapper>
        <S.CartTitleWrapper>
          <Text className="title">{title}</Text>

          {alert && (
            <Tooltip message={tooltipMessage ?? title}>
              <S.Icon className="danger-icon">
                <MdErrorOutline />
              </S.Icon>
            </Tooltip>
          )}
        </S.CartTitleWrapper>

        <Heading
          size={FontSize.font36}
          weight={FontWeight.xBold}
          className="fg-status-color"
        >
          {formatNumberEnsuringTwoDigits(quantity)}
        </Heading>

        <S.AnchorStyle>
          <Text weight={FontWeight.bold}>{buttonLabel}</Text>

          <S.Icon>
            <MdArrowForwardIos />
          </S.Icon>
        </S.AnchorStyle>
      </S.CardWrapper>

      <S.CardBottomLine className="bg-status-color" />
    </S.Card>
  );
}
